<template>
  <div>
    <app-loader v-show="$store.state.appConfig.showLoader" />
    <div
      v-if="showMessage"
      class="mobileWrapper floatCss"
    >
      <div class="personalData-wrapper floatCss">
        <div class="personalData-header floatCss">
          <b-row>
            <b-col cols="12">
              <div class="pdc-tittle-bar floatCss">
                <div class="pdc-back">
                  <div class="pdc-back-btn">
                    <b-button
                      class="pdc-btn-1"
                      @click="$router.go(-1)"
                    />
                  </div>
                  <div class="pdc-tittle-block">
                    <h3>Marketing consent</h3>
                  </div>
                </div>
                <div class="pdc-right-block">
                  <h3>{{ transferRequest.lotLocation }} / {{ transferRequest.nvsFileType }} • {{ transferRequest.lotType }}</h3>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
        <div class="personalData-content floatCss">
          <b-row>
            <b-col cols="12">
              <div class="personalData-content-info floatCss">
                <p>From time to time, the Group may use personal data disclosed by you in this Form to send you advertising and promotional material. If you do not wish to receive such material, kindly check the box below.</p>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <div class="pdc-check-wrapper floatCss">
                <div class="rv-single-input floatCss">
                  <b-form-checkbox
                    id="checkbox-1"
                    v-model="status"
                    name="checkbox-1"
                    value="accepted"
                    unchecked-value="not_accepted"
                  >
                    No, I would not like to receive advertising and promotional material from the Group.
                  </b-form-checkbox>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
      <div class="Purchaserdetails-bottom pdc-bottom floatCss">
        <b-row>
          <b-col cols="12">
            <b-button
              class="pr-btn-2"
              @click="saveMarketingDataConsent"
            >
              Save marketing consent
            </b-button>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BRow, BCol, BButton, BFormCheckbox,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import AppLoader from '../AppLoader.vue'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BFormCheckbox,
    AppLoader,
  },
  data() {
    return {
      sameAsCorrespondence: true,
      showMessage: false,
      tokenDetail: {},
      transferRequest: {},
      packageName: '',
      titleText: 'Change of Purchaser',
      status: 'not_accepted',
    }
  },
  beforeMount() {
    const { token } = this.$route.params
    if (token) {
      this.$http.get('front-end/file-transfer/file-detail', { params: { token } })
        .then(response => {
          if (response.data.success) {
            if (response.data.validToken) {
              this.tokenDetail = response.data.token || {}
              this.transferRequest = response.data.transferRequest || {}
              if (this.transferRequest.transferType === 'ownership') {
                this.titleText = 'Transfer of ownership'
              }
              this.packageName = response.data.packageName
              if (this.transferRequest.currentStatus === 'Pending NP') {
                this.showMessage = true
                this.status = this.transferRequest.marketingDataConsent ? 'accepted' : 'not_accepted'
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'You have already completed this step',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              }
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Expired link',
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              })
            }
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    }
  },
  methods: {
    saveMarketingDataConsent() {
      localStorage.setItem('fileTransferDraft_marketing', JSON.stringify({ status: this.status }))
      this.$router.push({ name: 'file-transfer-transferring-detail', params: { token: this.$route.params.token } })
    },
  },
}
</script>
